import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Form, Button } from 'react-bootstrap';
import {
  handleFieldChange,
  createUser,
  updateUser,
  getUser,
  resetUser,
  fetchSupervisors,
  PORTAL_ADMIN,
  MANAGER,
  TEAM_LEADER,
  EMPLOYEE,
  PROJECT_SPONSOR,
  PROJECT_ADMIN,
  HR_ADMIN,
  FINANCE_APPROVER,
  FINANCE_REPORTER
} from '../../../store/actions/users/usersActions';
import { fetchBands } from '../../../store/actions/bands/bandActions';
import { fetchPlatforms } from '../../../store/actions/platforms/platformActions';
import { getCurrentCostCenter } from '../../../store/actions/cost_centers/userCostCenterActions';
import { Cache } from 'aws-amplify';
import Select from 'react-select';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import SelectUserField from '../../../common/SelectUserField';
import PageTitle from '../../../common/PageTitle';
import DepartmentField from '../../../common/DepartmentField';
import CostCenterField from '../../../common/CostCenterField';

class UserForm extends Component {

  componentDidMount() {
    this.props.fetchPlatforms();
    this.props.fetchSupervisors();
    this.props.fetchBands();

    const roleId = Cache.getItem('roleId');
    if (roleId === PORTAL_ADMIN || roleId === HR_ADMIN) {
      window.scroll(0, 0);
      const pathname = this.props.location.pathname;
      if (pathname === '/settings/users/update') {
        this.action = 'UPDATE_USER';
        this.props.resetUser();

        const urlParams = new URLSearchParams(this.props.location.search);
        const userId = urlParams.get('id');
        this.props.getUser(userId);
      }
      else {
        this.action = 'CREATE_USER';
      }
    }
    else {
      this.props.history.push('/dashboard');
    }

    this.submitButtonText = "Submit";
  }

  componentWillUnmount() {
    this.props.resetUser();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.beforeSubmit();

    if (this.action === "UPDATE_USER") {
      this.props.updateUser(
        () => { this.props.history.push('/settings/users'); },
        this.afterSubmit,
        this.errorSubmit
      );
    }
    else {
      this.props.createUser(
        () => { this.props.history.push('/settings/users'); },
        this.afterSubmit,
        this.errorSubmit
      );
    }

  }

  errorSubmit = (selector = "button[type='submit']") => {
    const submitButton = document.querySelector(selector);
    submitButton.disabled = false;
    submitButton.textContent = this.submitButtonText;
  }

  beforeSubmit = (selector = "button[type='submit']") => {
    const submitButton = document.querySelector(selector);

    if (submitButton) {
      submitButton.disabled = true;
      if (this.submitButtonText === 'Create') {
        submitButton.textContent = "creating...";
      } else {
        submitButton.textContent = "updating...";
      }
    }
  }

  afterSubmit = (selector = "button[type='submit']") => {
    const submitButton = document.querySelector(selector);
    if (submitButton) {
      submitButton.disabled = false;
      if (this.submitButtonText === 'Create') {
        submitButton.textContent = "Created!";
      } else {
        submitButton.textContent = "Updated!";
      }
      setTimeout(() => {
        submitButton.textContent = this.submitButtonText;
      }, 1000);
    }
  }

  displayBands = (band) => {
    const bands = this.props.bands.bands;
    let defaultValueIndex = '';
    let bandOptions = [];

    const onChangeCallback = (value) => {
      this.props.handleFieldChange(null, {
        band_id: value.value
      });
    }

    if (!!bands && bands.length) {
      bandOptions = +bands.length && bands.map(band => {
        return {
          label: "Band " + band.band_name,
          value: band.id
        }
      })
    }

    if (band) {
      if (typeof (bandOptions) === 'object') {
        bandOptions.forEach((bandOpt, index) => {
          if (bandOpt.value === band) {
            defaultValueIndex = index;
          }
        })
      }
    }

    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="band_id">
            <Form.Label>Band<span className='required-field'> * </span></Form.Label>
            <Select
              value={bandOptions[defaultValueIndex]}
              isSearchable={true}
              name="band"
              isMulti={false}
              options={bandOptions}
              onChange={(value) => onChangeCallback(value)}
            />
          </Form.Group>
        </Col>
      </Row>
    )
  }

  displayGroup = (group) => {
    const groups = this.props.platforms.platforms;
    let defaultValueIndex = '';
    let groupOptions = [];

    const onChangeCallback = (value) => {
      this.props.handleFieldChange(null, {
        group_id: value.value
      });
    }

    groupOptions = groups.length && groups.map(group => {
      return {
        label: group.platform_name,
        value: group.id
      }
    })

    if (group) {
      if (typeof (groupOptions) === 'object') {
        groupOptions.forEach((groupOpt, index) => {
          if (groupOpt.value === group) {
            defaultValueIndex = index;
          }
        })
      }
    }

    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="group">
            <Form.Label>Group<span className='required-field'> * </span></Form.Label>
            <Select
              isSearchable={true}
              name="group"
              value={groupOptions[defaultValueIndex]}
              isMulti={false}
              options={groupOptions}
              onChange={(value) => onChangeCallback(value)}
            />
          </Form.Group>
        </Col>
      </Row>
    )
  }

  displaySups = (sup) => {
    const sups = this.props.users.supervisors;

    const onChangeCallback = (value) => {
      this.props.handleFieldChange(null, {
        supervisor_id: value.value
      });
    }

    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="team_leader">
            <Form.Label>MS Team Leader<span className='required-field'> * </span></Form.Label>
            <SelectUserField
              users={sups}
              defaultValue={sup}
              multiple={false}
              fieldName="team_leader"
              onChangeCallback={onChangeCallback}
            />
          </Form.Group>
        </Col>
      </Row>
    )
  }

  render() {
    let formTitle = 'Create User';

    let employeeId = '';
    let firstName = '';
    let middleName = '';
    let lastName = '';
    let email = '';
    let supervisorId = '';
    let band = '';
    let group = '';
    let department = '';
    let costCenter = '';
    let costCenterEffDate = '';

    let orgAdminSelected = false;
    let projManagerSelected = false;
    let teamLeaderSelected = false;
    let icSelected = false;
    let projSponsorSelected = false;
    let projAdminSelected = false;
    let hrAdminSelected = false;
    let finApproverSelected = false;
    let finReporterSelected = false;

    this.submitButtonText = 'Create';

    const user = this.props.users.user;

    if (this.action === "UPDATE_USER") {
      this.submitButtonText = 'Update';
      formTitle = 'Update User';
    }

    if (Object.keys(user).length > 0) {
      employeeId = user.employee_id ? user.employee_id.toString().padStart(5, "0") : "";
      firstName = user.first_name;
      middleName = user.middle_name;
      lastName = user.last_name;
      email = user.email;
      supervisorId = user.supervisor_id;
      band = user.band_id;
      group = user.group_id;
    }

    if (user.department && typeof (user.department.id) !== "undefined") {
      department = user.department.id;
    }

    if (typeof (user.cost_center_id) === "number") {
      costCenter = user.cost_center_id;
    }
    else if (typeof (user.user_cost_center) === "object") {
      let objCostCenter = getCurrentCostCenter(user.user_cost_center, moment());
      if (objCostCenter) {
        costCenter = objCostCenter.cost_center_id;
        costCenterEffDate = new Date(objCostCenter.effectivity_date);
      }

    }
    else if (typeof (user.user_cost_center) === "number") {
      costCenter = user.user_cost_center;
    }

    //if effectivity date is set, point the source in user object instead from user.user_cost_center
    if (typeof (user.effectivity_date) !== "undefined") {
      costCenterEffDate = new Date(user.effectivity_date);
    }

    const roles = user.roles;
    if (typeof (roles) !== "undefined") {
      roles.forEach(role => {
        let userRole = '';
        if (typeof (role.id) === "undefined") {
          userRole = role
        }
        else {
          userRole = role.id
        }

        userRole = parseInt(userRole);

        switch (userRole) {
          case PORTAL_ADMIN:
            orgAdminSelected = true;
            break;
          case TEAM_LEADER:
            teamLeaderSelected = true;
            break;
          case MANAGER:
            projManagerSelected = true;
            break;
          case EMPLOYEE:
            icSelected = true;
            break;
          case PROJECT_ADMIN:
            projAdminSelected = true;
            break;
          case PROJECT_SPONSOR:
            projSponsorSelected = true;
            break;
          case FINANCE_APPROVER:
            finApproverSelected = true;
            break;
          case HR_ADMIN:
            hrAdminSelected = true;
            break;
          case FINANCE_REPORTER:
            finReporterSelected = true;
            break;
          default:
            break;
        }
      })
    }

    return (
      <>
        <PageTitle pageName={formTitle} />
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Form onSubmit={this.handleSubmit}>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="employee_id">
                    <Form.Label>Employee ID<span className='required-field'> * </span></Form.Label>
                    <Form.Control type="text" name="employee_id" defaultValue={employeeId} onChange={this.props.handleFieldChange} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="first_name">
                    <Form.Label>First Name<span className='required-field'> * </span></Form.Label>
                    <Form.Control type="text" defaultValue={firstName} onChange={this.props.handleFieldChange} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="middle_name">
                    <Form.Label>Middle Name</Form.Label>
                    <Form.Control type="text" defaultValue={middleName} onChange={this.props.handleFieldChange} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="last_name">
                    <Form.Label>Last Name<span className='required-field'> * </span></Form.Label>
                    <Form.Control type="text" defaultValue={lastName} onChange={this.props.handleFieldChange} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="email">
                    <Form.Label>Email<span className='required-field'> * </span></Form.Label>
                    <Form.Control type="email" defaultValue={email} onChange={this.props.handleFieldChange} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="department">
                    <Form.Label>Department<span className='required-field'> * </span></Form.Label>
                    <DepartmentField department={department} onChangeCallback={(item) => {
                      this.disableSubmit = false;
                      this.props.handleFieldChange(null, {
                        department: item.value
                      });
                    }} />
                  </Form.Group>
                </Col>
              </Row>
              {this.displayBands(band)}
              {this.displayGroup(group)}
              {this.displaySups(supervisorId)}

              <Row className="mb-3">
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <b>User Cost Center</b>
                  <hr />
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="department">
                    <Form.Label>Cost Center<span className='required-field'> * </span></Form.Label>
                    <CostCenterField costCenter={costCenter} onChangeCallback={(item) => {
                      this.disableSubmit = false;
                      this.props.handleFieldChange(null, {
                        cost_center_id: item.value
                      });
                    }} />
                  </Form.Group>

                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="department">
                    <Form.Label>Effective Date<span className='required-field'> * </span></Form.Label>
                    
                    <DatePicker 
                      selected={costCenterEffDate} 
                      id="effective_date" 
                      autoComplete="off" 
                      className="form-control form-control-sm" 
                      maxDate={new Date()}
                      onChange={(date) => {
                          this.props.handleFieldChange(null, {
                            effectivity_date: date
                        })
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="role">
                    <Form.Label>Role<span className='required-field'> * </span></Form.Label>
                    <Form.Check
                      type="checkbox"
                      id="ic"
                      name="roles"
                      label="MS Employee"
                      value={EMPLOYEE}
                      checked={icSelected}
                      onChange={this.props.handleFieldChange}
                    />
                    <Form.Check
                      type="checkbox"
                      id="team_leader"
                      label="MS Team Leader"
                      name="roles"
                      value={TEAM_LEADER}
                      checked={teamLeaderSelected}
                      onChange={this.props.handleFieldChange}
                    />
                    <Form.Check
                      type="checkbox"
                      id="project_manager"
                      label="MS Manager"
                      name="roles"
                      value={MANAGER}
                      checked={projManagerSelected}
                      onChange={this.props.handleFieldChange}
                    />
                    <Form.Check
                      type="checkbox"
                      id="org_admin"
                      label="Portal Admin"
                      name="roles"
                      value={PORTAL_ADMIN}
                      checked={orgAdminSelected}
                      onChange={this.props.handleFieldChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <div className="align-right">
                    <Button variant="default" onClick={() => {
                      this.props.history.push('/settings/users');
                    }}>Cancel</Button>
                    <Button variant="primary" type="submit">{this.submitButtonText}</Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  bands: state.bands,
  platforms: state.platforms,
  departments: state.departments,
  common: state.common
})

const mapDispatchToProps = (dispatch) => {
  return {
    handleFieldChange: (...args) => dispatch(handleFieldChange(...args)),
    createUser: (...args) => dispatch(createUser(...args)),
    updateUser: (...args) => dispatch(updateUser(...args)),
    getUser: (...args) => dispatch(getUser(...args)),
    resetUser: () => dispatch(resetUser()),
    fetchSupervisors: () => dispatch(fetchSupervisors()),
    fetchBands: () => dispatch(fetchBands()),
    fetchPlatforms: () => dispatch(fetchPlatforms())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserForm))
